import { useMemo } from 'react'

import { fromGlobalId } from 'utils/transformations/graphql'

import usePortal from 'hooks/usePortal'

import SendInvoiceModal from 'modals/OrderList/SendInvoiceModal'
import { InvoiceModalOrder } from 'modals/OrderList/SendInvoiceModal/SendInvoiceModal.component'

import { TableRowData } from '../../joorPayOrders.types'
import { formatOrderAddress } from 'features/Orders/Review/utils/addresses.utils'

export function SendInvoiceModalContainer({
  onClose,
  selectedOrders,
  onSuccess,
}: Props) {
  const Portal = usePortal()

  const invoiceOrders: InvoiceModalOrder[] = useMemo(
    () =>
      selectedOrders.map((order) => ({
        id: order.id,
        webOrderLookupId: fromGlobalId(order.webOrderLookupId).id ?? '',
        referenceNumber: order.poNumber,
        shippingEmail: order.shippingEmail ?? '',
        retailer: { id: order.retailerId ?? '' },
        retailerName: order.retailerName,
        brand: { id: order.brandId },
        billingAddress:
          formatOrderAddress({
            firstAddress: order.billingFirstAddress,
            secondAddress: order.billingSecondAddress,
            city: order.billingCity,
            country: order.billingCountry,
            zip: order.billingZip,
          }) || undefined,
        retailerEmail: order.shippingEmail ?? undefined,
        currency: order.currency,
        amount: order.remainingBalance.toFixed(2),
      })),
    [selectedOrders],
  )

  return (
    <Portal>
      <SendInvoiceModal
        onClose={onClose}
        selectedOrders={invoiceOrders}
        onSuccess={onSuccess}
      />
    </Portal>
  )
}

type Props = {
  onClose: () => void
  selectedOrders: TableRowData[]
  onSuccess?: (updatedIds: string[]) => void
}
